import { storage } from './firebase'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'

// Upload profile image to Firebase Storage
export const uploadProfileImage = async (file, userId) => {
  const timestamp = Date.now()
  const fileName = `${timestamp}_${file.name}`
  const storageRef = ref(storage, `profile-images/${userId}/${fileName}`)

  const snapshot = await uploadBytes(storageRef, file)
  const downloadURL = await getDownloadURL(snapshot.ref)

  return { secure_url: downloadURL }
}

// Upload portfolio image to Firebase Storage
export const uploadPortfolioImage = async (file, userId) => {
  const timestamp = Date.now()
  const fileName = `${timestamp}_${file.name}`
  const storageRef = ref(storage, `portfolio-images/${userId}/${fileName}`)

  const snapshot = await uploadBytes(storageRef, file)
  const downloadURL = await getDownloadURL(snapshot.ref)

  return { secure_url: downloadURL }
}

// Upload background image to Firebase Storage
export const uploadBackgroundImage = async (file, userId) => {
  const timestamp = Date.now()
  const fileName = `${timestamp}_${file.name}`
  const storageRef = ref(storage, `background-images/${userId}/${fileName}`)

  const snapshot = await uploadBytes(storageRef, file)
  const downloadURL = await getDownloadURL(snapshot.ref)

  return { secure_url: downloadURL }
}

// Upload team image to Firebase Storage (for AboutUs page)
export const uploadTeamImage = async (file) => {
  const timestamp = Date.now()
  const fileName = `${timestamp}_${file.name}`
  const storageRef = ref(storage, `team-images/${fileName}`)

  const snapshot = await uploadBytes(storageRef, file)
  const downloadURL = await getDownloadURL(snapshot.ref)

  return { url: downloadURL, public_id: snapshot.ref.fullPath }
}

